module.exports = __webpack_public_path__ + "img/desking.93b3d6df.svg";